import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconExteriorHouse(props: SvgIconProps) {
  return (
    <SVGIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeLinejoin="round"
      {...props}
    >
      <path
        d="m4.4966 10.5102v5.9594l7.5305 3.8465v-5.526L8.291 8.493l-3.799 2.01L15.7111 4.5508l3.7381 6.0677v5.7427l-7.4221 3.9549v-5.526L19.447 10.613"
        stroke="currentColor"
        strokeLinejoin="round"
        pathLength="1" // used by ui/components/LoadingHouse to animate
      />
    </SVGIcon>
  );
}
